import { render, staticRenderFns } from "./c-patient-settings-dialog.vue?vue&type=template&id=86b23582&scoped=true&"
import script from "./c-patient-settings-dialog.vue?vue&type=script&lang=js&"
export * from "./c-patient-settings-dialog.vue?vue&type=script&lang=js&"
import style0 from "./c-patient-settings-dialog.vue?vue&type=style&index=0&id=86b23582&lang=scss&scoped=true&"
import style1 from "./c-patient-settings-dialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b23582",
  null
  
)

export default component.exports